import {computed, inject} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {signalStore, withComputed, withMethods, withProps} from '@ngrx/signals';
import {TechnologiesApi} from "../../../../../core/data/technologies/technologies.api";
import {Technology} from "../../../../../core/data/technologies/technologies.schema";

export enum TechnologyStack {
  BackendArchitecture = 'BackendArchitecture',
  Frontend = 'Frontend',
  MobileDevelopment = 'MobileDevelopment',
  Databases = 'Databases',
  CmsBaas = 'CmsBaas',
  DevOpsObservability = 'DevOpsObservability',
  QualityAssurance = 'QualityAssurance',
}

export const TechnologiesStore = signalStore(
  withProps((store, partnerApi = inject(TechnologiesApi)) => {
    return {
      _technologies: rxResource({
        stream: () => partnerApi.getTechnologies(),
      }),
    };
  }),

  withComputed(({ _technologies }) => {
    const technologies = computed<Technology[]>(() => {
      const data = _technologies.value() ?? [];

      return data.map(t => ({
        ...t,
        stack: t.stack as TechnologyStack,
      }));
    });

    const groupedByStack = computed(() => {
      return Object.values(TechnologyStack)
        .map(stack => ({
          stack,
          items: technologies().filter(t => t.stack === stack),
        }))
        .filter(group => group.items.length > 0); // ✅ remove empty groups
    });
    const isLoading = computed(() => _technologies.isLoading());

    return {
      technologies,
      groupedByStack,
      isLoading
    };
  }),

  withMethods((store) => ({
    reload: () => {
      if (store._technologies.error()) {
        store._technologies.reload();
      }
    },
  })),
);
